import Invoice from "../Components/Invoice/Invoice";
import Account from "../Pages/Account/Account";
import AccountDetails from "../Pages/Account/AccountDetails";
import Addresses from "../Pages/Account/Addresses";
import Downloads from "../Pages/Account/Downloads";
import EmailVerification from "../Pages/Account/EmailVerification";
import ManageAddress from "../Pages/Account/ManageAddress";
import MyOrders from "../Pages/Account/MyOrders";
import OrderDetails from "../Pages/Account/OrderDetails";
import Signup from "../Pages/Account/Signup";
import CarVin from "../Pages/Cars/CarVIn";
import Cart from "../Pages/Carts/Cart";
import Checkout from "../Pages/Carts/Checkout";
import Success from "../Pages/Carts/Success";
import Home from "../Pages/Home/Home";
import MapHome from "../Pages/Map/MapHome";

import Catelog from "../Pages/SpareParts/Catelog/Catelog";
import MakesModels from "../Pages/SpareParts/MakesModels";
import PartDetails from "../Pages/SpareParts/PartDetails/PartDetails";

import Parts from "../Pages/SpareParts/Parts";
import PartsBySuppliers from "../Pages/SpareParts/PartsBySuppliers";
import SupplierCatelog from "../Pages/SpareParts/SupplierCatelog";
import Suppliers from "../Pages/SpareParts/Suppliers";
import WishList from "../Pages/WishList/WishList";
import ForgetPassword from "../Pages/Account/ForgetPassword";
import ResetPassword from "../Pages/Account/ResetPassword";
import PageNotFound from "../Pages/Statics/PageNotFound";
import NoResults from "../Pages/SpareParts/NoResults";
import NoCarSelected from "../Pages/SpareParts/NoCarSelected";
import Pages from "../Pages/Statics/Pages";
import Contact from "../Pages/Statics/Contact";
import OEPartDetails from "../Pages/SpareParts/OEPartDetails/OEPartDetails";
import Failure from "../Pages/Carts/Failure";
import AllMakesList from "../Pages/SpareParts/Catelog/AllMakesList";
import MakeSection from "../Pages/SpareParts/Catelog/MakeSection";
import Basket from "../Pages/Carts/Basket/Basket";
import { Navigate } from "react-router-dom";
import MobBasket from "../Pages/Carts/MobBasket/MobBasket";
import MobParts from "../Pages/SpareParts/MobParts";
import ByBrands from "../Pages/SpareParts/ByBrands";
import CreditStatement from "../Pages/Account/CreditStatement";
import ByDepartment from "../Pages/SpareParts/ByDepartment";
import RedeemPoints from "../Pages/Account/RedeemPoints";
import RedeemPointsDetails from "../Pages/Account/RedeemPointsDetails";
import LoginPage from "../Pages/LoginPage";
import BulkPricing from "../Pages/SpareParts/BulkPricing";
import SpecialOffers from "../Pages/SpareParts/SpecialOffers";
import Registration from "../Pages/Account/Registration";
import Favourites from "../Pages/Account/Favourites";
import CrossFitParts from "../Pages/SpareParts/CrossFitParts";
import AccountLocked from "../Pages/Account/AccountLock";
import PartDetailsSearch from "../Pages/SpareParts/PartDetails/PartDetailsSearch";
import RequestedRedeemPoints from "../Pages/Account/RequestedRedeemPoints";
import OrderPrintDownload from "../Pages/Account/OrderPrintDownload";
import Temp from "../Pages/Temp";
import CreditApplicationForm from "../Pages/Account/CreditApplicationForm";
import PlaceOrder from "../Pages/Carts/PlaceOrder";
import CreditApplication from "../Pages/Home/CreditApplication";
import RequestCreditList from "../Pages/Account/RequestCreditList";
import RequestStatementAccount from "../Pages/Account/Statement/RequestStatementAccount";
import ByOEBrands from "../Pages/SpareParts/ByOEBrands";
import OilSaleParts from "../Pages/SpareParts/OilSale/OilSaleParts";
import OilSaleDetails from "../Pages/SpareParts/OilSale/OilSaleDetails";
import MyCreditNote from "../Pages/Account/CreditNote/MyCreditNote";
import PreviewCreditNote from "../Pages/Account/CreditNote/PreviewCreditNote";
import MembershipPolicy from "../Pages/Home/MembershipPolicy";
import RewardsPolicy from "../Pages/Statics/RewardsPolicy";
import ViewOrdersInvoice from "../Pages/Account/ViewOrdersInvoice";
import Batteries from "../Pages/SpareParts/CarBatteries/Batteries";
import OilLubes from "../Pages/SpareParts/OilSale/OilLubes";
import Wiper from "../Pages/SpareParts/Wiper";


const PrivateRoute = ({ element, ...rest }) => {
  const userLoggedIn = localStorage.getItem('business_id') === '' || localStorage.getItem('business_id') === null || localStorage.getItem('business_id') === '0' ? false : true;
  return (userLoggedIn ? element : <Signup />)
};
// routes.js
const routesNoLogin = [
  { path: '/Registration', element: <Registration /> },
  { path: '/Forget-Password', element: <ForgetPassword /> },
  { path: '/Reset-Password/:reset_password_token', element: <ResetPassword /> },
  { path: '/EmailVerification/:token', element: <EmailVerification /> },
  { path: '/Temp', element: <Temp /> },
  { path: '/', element: <LoginPage /> },
  { path: '*', element: <LoginPage /> },
]

const routesAll = [
  { path: '/', element: <Home /> },
  { path: '*', element: <PageNotFound /> },
  { path: '/MapTest', element: <MapHome /> },
  { path: '/AccountLocked', element: <AccountLocked /> },
  { path: '/Signup', element: <Signup /> },
  { path: '/Login', element: <Signup /> },




  { path: '/Cart', element: <Cart /> },
  { path: '/PlaceOrder', element: <PlaceOrder /> },

  { path: '/CreditApplicationForm', element: <CreditApplicationForm /> },
  { path: '/Contact', element: <Contact /> },
  { path: '/Aboutus', element: <Pages page="Aboutus" /> },
  { path: '/Faqs', element: <Pages page="Faqs" /> },
  { path: '/RewardsPolicy', element: <PrivateRoute element={<RewardsPolicy />} /> },

  { path: '/Delivery', element: <Pages page="Delivery" /> },
  { path: '/Warranty-Coverage', element: <Pages page="Warranty-Coverage" /> },
  { path: '/Privacy-Policy', element: <Pages page="Privacy-Policy" /> },
  { path: '/International-Customers', element: <Pages page="International-Customers" /> },
  { path: '/Cancelation', element: <Pages page="Cancelation" /> },
  { path: '/Easy-way-to-Shop', element: <Pages page="Easy-way-to-Shop" /> },
  { path: '/Safe-Shopping', element: <Pages page="Safe-Shopping" /> },
  { path: '/Car-Parts-Online', element: <Pages page="Car-Parts-Online" /> },
  { path: '/Attractive-Prices', element: <Pages page="Attractive-Prices" /> },
  { path: '/Brands', element: <Pages page="Brands" /> },
  { path: '/Careers', element: <Pages page="Careers" /> },
  { path: '/WishList', element: <PrivateRoute element={<WishList />} /> },
  { path: '/Checkout', element: <Checkout /> },
  { path: '/OrderInformation/:order_uid', element: <Success /> },
  { path: '/FailureOrderInformation/:order_uid?', element: <Failure /> },
  { path: '/Invoice', element: <Invoice /> },

  ////////////////////// Master's Routing ///////////////////////////

  // { path:'/Part/:part_uid/:part_id/:part_title_en/:PartNumber', element:<PartDetail /> },

  { path: '/VIN/:vin', element: <CarVin /> },
  { path: '/Spare-Parts/Catelog', element: <Catelog /> },
  { path: '/Spare-Parts/Batteries', element: <Batteries /> },
  { path: '/Spare-Parts/OilsLubes', element: <OilLubes /> },
  { path: '/Spare-Parts/Wipers', element: <Wiper /> },

  { path: '/Spare-Parts/PartsByBrand/:brand?', element: <ByBrands /> },
  { path: '/Spare-Parts/PartsByOEBrand/:brand?', element: <ByOEBrands /> },


  { path: '/Spare-Parts/OEM/:slug', element: <CrossFitParts /> },
  { path: '/Spare-Parts/BulkPricing', element: <BulkPricing /> },
  { path: '/Spare-Parts/SpecialOffers', element: <SpecialOffers /> },
  { path: '/Spare-Parts/ByDepartment/:STR_ID/:STR_NODE_NAME?', element: <ByDepartment /> },
  { path: '/Spare-Parts/Catelog/:s_str_id?', element: <Catelog /> },
  { path: '/Spare-Parts/:slug?/:make?/:year?/:model?/:engine?/:fuel?', element: window.innerWidth <= 768 ? <MobParts /> : <Parts /> },
  { path: '/Spare-Parts-nocar/:slug?/:make?/:model?/:series?', element: <NoCarSelected /> },
  { path: '/Spare-Parts/Spare-Parts-nocar/:STR_ID/:STR_NODE_NAME', element: <NoCarSelected /> },
  { path: '/Spare-Parts-No-Results/:keyword?', element: <NoResults /> },
  { path: '/Spare-Parts-Supplier/:slug/:sup_id/:sup_name', element: localStorage.getItem('pc_id') && localStorage.getItem('pc_id') !== 0 && localStorage.getItem('pc_id') !== null ? <PartsBySuppliers /> : <NoCarSelected /> },
  { path: '/Spare-Parts/Details/:part_slug', element: <PartDetails /> },
  { path: '/Spare-Parts-Search/Details/:part_slug', element: <PartDetailsSearch /> },

  { path: '/Supplier-Catelog/:slug', element: <SupplierCatelog /> },
  { path: '/Suppliers', element: <Suppliers /> },
  { path: '/Car-Brands', element: <AllMakesList /> },
  { path: '/Car-Brands/:make', element: <MakeSection /> },
  { path: '/Car-Brands/:make/:model?', element: <MakeSection /> },
  { path: '/Makes/:mf_name/:mfa_id', element: <MakesModels /> },
  // { path: '/OE-Spare-Parts/:car_make/:part_slug', element: <OEPartDetails /> },
  { path: '/OE-Spare-Parts/Details/:part_slug/:brand_name', element: <OEPartDetails /> },

  ////////////////////////////// BASKET /////////////////
  { path: '/basket', element: window.innerWidth <= 768 ? <MobBasket default={0} /> : <Basket default={0} /> },
  {
    path: '/basket/login', element: localStorage.getItem('token') && localStorage.getItem('business_id')
      ? <Navigate to="/basket/address" replace />
      : window.innerWidth <= 768 ? <MobBasket default={1} /> : <Basket default={1} />
  },
  {
    path: '/basket/address', element: localStorage.getItem('token') && localStorage.getItem('business_id')
      ? window.innerWidth <= 768 ? <MobBasket default={2} /> : <Basket default={2} />
      : <Navigate to="/basket/login" replace />
  },
  {
    path: '/basket/payment', element: localStorage.getItem('token') && localStorage.getItem('business_id')
      ? window.innerWidth <= 768 ? <MobBasket default={3} /> : <Basket default={3} />
      : <Navigate to="/basket/login" replace />
  },
  {
    path: '/basket/confirm', element: localStorage.getItem('token') && localStorage.getItem('business_id')
      ? window.innerWidth <= 768 ? <MobBasket default={4} /> : <Basket default={4} />
      : <Navigate to="/basket/login" replace />
  },

  ////////////////////////////// BASKET /////////////////

  ////////////////////// MyAccount Routing ///////////////////////////
  { path: '/MyAccount', element: <PrivateRoute element={<Account />} /> },
  { path: '/MyAccount/Dashboard', element: <PrivateRoute element={<Account />} /> },
  { path: '/MyAccount/Favourites', element: <PrivateRoute element={<Favourites />} /> },
  { path: '/MyAccount/CreditStatement', element: <PrivateRoute element={<CreditStatement />} /> },
  { path: '/MyAccount/RedeemPoints', element: <PrivateRoute element={<RedeemPoints />} /> },
  { path: '/MyAccount/Addresses', element: <PrivateRoute element={<Addresses />} /> },
  { path: '/MyAccount/ManageAddress', element: <PrivateRoute element={<ManageAddress />} /> },
  { path: '/MyAccount/EditAddress/:address_id', element: <PrivateRoute element={<ManageAddress />} /> },
  { path: '/MyAccount/Orders', element: <PrivateRoute element={<MyOrders />} /> },
  { path: '/MyAccount/Orders/:order_uid', element: <PrivateRoute element={<OrderDetails />} /> },
  { path: '/MyAccount/Orders/Download/:order_uid', element: <PrivateRoute element={<OrderPrintDownload />} /> },
  { path: '/MyAccount/Orders/Print/:order_uid', element: <PrivateRoute element={<OrderPrintDownload />} /> },
  { path: '/MyAccount/Orders/ViewInvoice/:order_id?/:invoice_id?/:invoice_no?', element: <PrivateRoute element={<ViewOrdersInvoice />} /> },
  { path: '/MyAccount/Downloads', element: <PrivateRoute element={<Downloads />} /> },
  { path: '/MyAccount/AccountDetails', element: <PrivateRoute element={<AccountDetails />} /> },
  { path: '/MyAccount/RequestedRedeemPoints', element: <PrivateRoute element={<RequestedRedeemPoints />} /> },
  { path: '/MyAccount/RedeemPointsDetails/:business_redeem_offer_id?', element: <PrivateRoute element={<RedeemPointsDetails />} /> },
  { path: '/MyAccount/CreditApplication', element: <PrivateRoute element={<CreditApplication />} /> },
  { path: '/MyAccount/RequestCreditList', element: <PrivateRoute element={<RequestCreditList />} /> },
  { path: '/MyAccount/RequestStatementAccount', element: <PrivateRoute element={<RequestStatementAccount />} /> },
  { path: '/MyAccount/MyCreditNote', element: <PrivateRoute element={<MyCreditNote />} /> },
  { path: '/MyAccount/PreviewCreditNote/:voucher_id', element: <PrivateRoute element={<PreviewCreditNote />} /> },


  ///////////////////////////////// Oil Sale Module ///////////////////////////////// 
  { path: '/Spare-Parts/Oil', element: <PrivateRoute element={<OilSaleParts />} /> },
  { path: '/Spare-Parts/Oil-Details/:product_number?/:product_id?', element: <PrivateRoute element={<OilSaleDetails />} /> }

];

const routes = localStorage.getItem('business_id') ? routesAll : routesNoLogin;

export default routes;
